export default __webpack_public_path__ + "static/media/CalendarMonthRounded.c3c9f8d2.svg";